import { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { injectedProvider } from "./wallet-connector";
import layer6 from "../images/layer6.png";
import cityFountain from "../images/fountain.png";
import bubbler from "../abi/bubbler.json";
import fountain from "../abi/fountain.json";
import WOW from 'wowjs';
import shuffle from "./shuffle.svg";
import { useEffect } from "react";
import { useWeb3React } from "@web3-react/core";

const Fountain = (passweb) => {

  var {
    account,
    activate,
    active,
    chainId,
    connector,
    deactivate,
    error,
    provider,
    setError
    } = useWeb3React();

  const [tokenBalance, setTokenBalance] = useState("");
  const [deposits, setDeposits] = useState("");
  const [maxPayout, setmaxPayout] = useState("");
  const [etherBalance, setEtherBalance] = useState("");
  const [resp_, setResp_] = useState("");
  const [eBalance0_, setEth_balance] = useState("");
  const [resp_raw, setResp_raw] = useState("");
  const [eBalance0_raw, setEth_balance_raw] = useState("");
  const [ER, setER] = useState("");
  const [MR, setMR] = useState("");
  const [ER_sell, setER_sell] = useState("");
  const [MR_sell, setMR_sell] = useState("");
  const [price, setPrice] = useState("");

  const [asset1, setAsset1] = useState("PLS");
  const [asset2, setAsset2] = useState("BUR");
  const [swapCall, setSwapCall] = useState("Buy");
  

  useEffect(() => {

    document.getElementsByClassName("bg-video")[0].style.display="none";
    document.getElementsByClassName("sectionn")[0].style.display="none";

    new WOW.WOW({
      live: true
    }).init();

     if (typeof window.ethereum !== 'undefined') {
          console.log('MetaMask is installed!');
          getData().then(()=>{});
                      }
      else {}
   }, []);

  window.onload = ()=>{
    
  }


 const [amount, setAmount] = useState("");

 const buy = async () => {
  let { provider } = await injectedProvider.activate();
  let web3 = new passweb.webtype(provider);
  const WF_CONTRACT = await new web3.eth.Contract(fountain, "0xd0866F3A3Bc1C455f5FCD97fca0B316D1f0C694e");
  const accounts = await web3.eth.getAccounts();
  let buyAmount = document.getElementById("input01").value;
  	//buyAmount = web3.utils.toWei(buyAmount.toString());
  	document.getElementById("div1").style.opacity= "1";
    const resp = await WF_CONTRACT.methods.bnbToTokenSwapInput(buyAmount).send({
            from: accounts[0],
            gas: '900000',
            value: buyAmount
             }).then(() => {
            alert("good to go");
            getData();
            document.getElementById("div1").style.opacity= "0";
         }).catch((err) => {
            console.log(err);
            document.getElementById("div1").style.opacity= "0";
         });      

    }


  const sell = async () => {
  let { provider } = await injectedProvider.activate();
  let web3 = new passweb.webtype(provider);
  const WF_CONTRACT = await new web3.eth.Contract(fountain, "0xd0866F3A3Bc1C455f5FCD97fca0B316D1f0C694e");
  const accounts = await web3.eth.getAccounts();
  let sellAmount = document.getElementById("input01").value;
  //let sellAmount = dummyString.replace(".",'');
  console.log(sellAmount);
  	document.getElementById("div1").style.opacity= "1";
    const resp = await WF_CONTRACT.methods.tokenToBnbSwapInput(sellAmount+"000000000000000000",1).send({
            from: accounts[0],
            gas: '900000'
             }).then(() => {
            alert("good to go");
            getData();
            document.getElementById("div1").style.opacity= "0";
         }).catch((err) => {
            console.log(err);
            document.getElementById("div1").style.opacity= "0";
         });      

    }

  

  const getData = async () => {
      let { provider } = await injectedProvider.activate();
      let web3 = new passweb.webtype(provider);      
      const EARTH_CONTRACT = await new web3.eth.Contract(bubbler,"0x3fce1Fc6369C93BbB91BA00bD51dE3De2A5E085A");
      const WF_CONTRACT = await new web3.eth.Contract(fountain, "0xd0866F3A3Bc1C455f5FCD97fca0B316D1f0C694e");
      var resp0 = await WF_CONTRACT.methods.getTokenToBnbInputPrice("1000000000000000000").call();
      resp0 = resp0/1000000000000000000;
      setPrice(resp0.toFixed(9));
      const accounts = await web3.eth.getAccounts();
      //const resp = await PROXY_CONTRACT.methods.userInfo(accounts[0]).call();
      let resp2 = await EARTH_CONTRACT.methods.balanceOf(accounts[0]).call();
      let eBalance = await web3.eth.getBalance(accounts[0]);
      setTokenBalance((resp2/10e17).toFixed(2));
      //const maxPayout = await PROXY_CONTRACT.methods.maxPayoutOf(resp.deposits).call();
      //let eBalance = await HEX_CONTRACT.methods.balanceOf(accounts[0]).call();
      //let eBalance0=parseInt(eBalance)/1e8;
      setResp_raw(resp2);
      //setEth_balance_raw(parseInt(eBalance))
      //setEth_balance(eBalance0);
      setResp_(parseInt(resp2));
      //eBalance0 = eBalance0.toFixed(5);
        setEtherBalance(eBalance/1e18);

  }

  const GetEthMax = async () => {
      //document.getElementById("af-bt").value = eBalance0_;
  }

  const GetEarthMax = async () => {
      //document.getElementById("af-st").value = resp_/10e17;
  }

  const getER = async () => {
  	let { provider } = await injectedProvider.activate();
  let web3 = new passweb.webtype(provider);
  const WF_CONTRACT = await new web3.eth.Contract(fountain, "0xd0866F3A3Bc1C455f5FCD97fca0B316D1f0C694e");
  const accounts = await web3.eth.getAccounts();
  if(document.getElementById("input01").value==0){setER(0); setMR(0);}
  const resp = await WF_CONTRACT.methods.getBnbToTokenInputPrice(document.getElementById("input01").value).call();
  //console.log(resp);
  setER(resp);
  //const resp2 = resp-(resp*(1/100));
  document.getElementById("input02").value= resp;
  setMR(resp);
 
  }

  const getER_sell = async () => {
  	let { provider } = await injectedProvider.activate();
  let web3 = new passweb.webtype(provider);
  const WF_CONTRACT = await new web3.eth.Contract(fountain, "0xd0866F3A3Bc1C455f5FCD97fca0B316D1f0C694e");
  const accounts = await web3.eth.getAccounts();
  if(document.getElementById("input01").value==0){setER_sell(0); setMR_sell(0);}
  const resp = await WF_CONTRACT.methods. getTokenToBnbInputPrice(document.getElementById("input01").value+"000000000000000000").call();
  //TAX
  const resp2 = (resp/1000000000000000000)-((resp/1000000000000000000)*(5/100));
  setER_sell(resp2);
  document.getElementById("input02").value= resp2;
  setMR_sell(resp2);
  }

  const Approve_sell_contract = async () => {
  		let { provider } = await injectedProvider.activate();
  		let web3 = new passweb.webtype(provider);
  		const EARTH_CONTRACT = await new web3.eth.Contract(bubbler,"0x3fce1Fc6369C93BbB91BA00bD51dE3De2A5E085A");
		const accounts = await web3.eth.getAccounts();
		document.getElementById("div1").style.opacity= "1";
    	const resp = await EARTH_CONTRACT.methods.approve("0xd0866F3A3Bc1C455f5FCD97fca0B316D1f0C694e","1000000000000000000000000000000000000").send({
            from: accounts[0],
            gas: '900000'
             }).then(() => {
            alert("good to go");
            document.getElementById("div1").style.opacity= "0";
         }).catch((err) => {
            console.log(err);
            document.getElementById("div1").style.opacity= "0";
         });      	


  }

  const swapTokens = async (n) => {
  		if(n==="Buy") buy();
  		else if(n==="Sell") sell();

  }

  const switchTokenField = async () => {
  		if(asset1==="PLS"){setAsset1("BUR"); setAsset2("PLS"); setSwapCall("Sell");}
  		if(asset1==="BUR"){setAsset1("PLS"); setAsset2("BUR"); setSwapCall("Buy");}
}

  const inputFunction = async () => {
  		if(swapCall==="Buy") getER();
  		else if(swapCall==="Sell") getER_sell()

  }


  return (
    <div>
     
     <div className="App-box">
     	<div className="box-1">
      		<div className="input1"><input type="text" id="input01" onChange={inputFunction}/><span>{asset1}</span></div>
      		<div className="shuffle_" onClick={switchTokenField}><img className="shuffle" src={shuffle}></img></div>
      		<div className="input2"><input type="text" id="input02" onChange={getER_sell}/><span>{asset2}</span></div>
      		<button onClick={()=>swapTokens(swapCall)} className="submt">{swapCall}</button>
     	</div>
  	 </div>

  	 <div>
            <ul className="settings-list4">
            <li>♢ BubbleR price = {active?price+" Pulse/BubbleR":"-- Pulse/BubbleR"}</li>
            <li>♢ User Pulse balance {active?etherBalance:"0.000"}</li>
            <li>♢ User BubbleR balance {active?tokenBalance:"0.000"}</li>
          </ul>
        </div>

    </div>


      );
	};

export default Fountain;